import Vue from "vue";
import Vuex from "vuex";

import viewport from "./viewport";
import sections from "./sections";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuOpen: false
  },
  mutations: {
    openMenu(state) {
      state.menuOpen = true;
    },
    hideMenu(state) {
      state.menuOpen = false;
    },
    toggleMenu(state) {
      state.menuOpen = !state.menuOpen;
    }
  },
  modules: {
    viewport,
    sections
  }
});
